import './scholar.css';
import React, {useEffect, useState} from 'react';
import {Link} from "react-router-dom";

const ScholarPage = () => {
    const [token, setToken] = useState('');
    const [scholarships, setScholarships] = useState([]);
    const [filteredScholarships, setFilteredScholarships] = useState([]);
    const [userInfo, setUserInfo] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [selectedYear, setSelectedYear] = useState('all');
    const [selectedHakgi, setSelectedHakgi] = useState('all');

    // 금액 포맷팅 함수
    const formatAmount = (amount) => {
        if (!amount) return '0';
        return parseInt(amount).toLocaleString();
    };

    // 학기 표시 함수
    const formatSemester = (hakgi) => {
        switch(hakgi) {
            case '1': return '1학기';
            case '2': return '2학기';
            case '3': return '여름계절';
            case '4': return '겨울계절';
            default: return hakgi + '학기';
        }
    };

    // 년도 목록 생성
    const getYearOptions = () => {
        const years = [...new Set(scholarships.map(s => s.year))].sort().reverse();
        return years;
    };

    // 학기 목록 생성
    const getHakgiOptions = () => {
        const hakgis = [...new Set(scholarships.map(s => s.hakgi))].sort();
        return hakgis;
    };

    // 필터링 함수
    const filterScholarships = () => {
        let filtered = scholarships;

        if (selectedYear !== 'all') {
            filtered = filtered.filter(s => s.year === selectedYear);
        }

        if (selectedHakgi !== 'all') {
            filtered = filtered.filter(s => s.hakgi === selectedHakgi);
        }

        setFilteredScholarships(filtered);
    };

    // 필터 변경 시 필터링 실행
    useEffect(() => {
        filterScholarships();
    }, [selectedYear, selectedHakgi, scholarships]);

    // 장학금 조회 함수
    const fetchScholarships = async (hakbun) => {
        if (!hakbun) {
            setError('학번 정보가 없습니다.');
            return;
        }

        setLoading(true);
        setError('');
        
        const secretKey = localStorage.getItem('secretKey');
        const storedToken = localStorage.getItem('token');

        try {
            const response = await fetch(`/backend/scholar.php?token=${encodeURIComponent(storedToken)}&secretKey=${encodeURIComponent(secretKey)}&hakbun=${encodeURIComponent(hakbun)}`);
            const data = await response.json();

            if (data.status === 'success') {
                setScholarships(data.data.scholarships || []);
                // 필터 초기화
                setSelectedYear('all');
                setSelectedHakgi('all');
                if (data.data.scholarships && data.data.scholarships.length === 0) {
                    setError('해당 학번의 장학금 정보가 없습니다.');
                }
            } else {
                setError(data.message || '장학금 조회 중 오류가 발생했습니다.');
            }
        } catch (err) {
            console.error(err);
            setError('서버 연결 오류가 발생했습니다.');
        } finally {
            setLoading(false);
        }
    };

    // 사용자 정보 가져오기 및 자동 장학금 조회
    useEffect(() => {
        const secretKey = localStorage.getItem('secretKey');
        const storedToken = localStorage.getItem('token');
        if (storedToken) {
            setToken(storedToken);
            
            // 학기 정보 API에서 사용자 학번 가져오기
            fetch(`/backend/hakgi_info?token=${encodeURIComponent(storedToken)}&secretKey=${encodeURIComponent(secretKey)}`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({})
            })
            .then(res => res.json())
            .then(data => {
                setUserInfo(data);
                if (data.HAKBUN) {
                    // 자동으로 본인 장학금 조회
                    fetchScholarships(data.HAKBUN);
                }
            })
            .catch(console.error);
        }
    }, []);

    return (
        <div className="App App-header gnb_b" id="scholar">
            <header>
                <div className="gnb_1">
                    <Link className="gnb_logo" to="/"></Link>
                </div>
            </header>
            <div className="body">
                <div className="main_box_gnbs">
                    <span>장학조회</span>
                    {userInfo.HAKBUN && (
                        <span>[{userInfo.HAKBUN}] {userInfo.YEAR}년 {userInfo.HAKGI}학기</span>
                    )}
                </div>

                {/* 필터 영역 */}
                {scholarships.length > 0 && (
                    <div className="filter-box">
                        <div className="filter-group">
                            <label htmlFor="year-select">학년도:</label>
                            <select 
                                id="year-select"
                                value={selectedYear} 
                                onChange={(e) => setSelectedYear(e.target.value)}
                                className="filter-select"
                            >
                                <option value="all">전체</option>
                                {getYearOptions().map(year => (
                                    <option key={year} value={year}>{year}년</option>
                                ))}
                            </select>
                        </div>
                        <div className="filter-group">
                            <label htmlFor="hakgi-select">학기:</label>
                            <select 
                                id="hakgi-select"
                                value={selectedHakgi} 
                                onChange={(e) => setSelectedHakgi(e.target.value)}
                                className="filter-select"
                            >
                                <option value="all">전체</option>
                                {getHakgiOptions().map(hakgi => (
                                    <option key={hakgi} value={hakgi}>{formatSemester(hakgi)}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                )}

                {/* 에러 메시지 */}
                {error && (
                    <div className="error-message">
                        {error}
                    </div>
                )}

                {/* 장학금 목록 */}
                <div className="menubox">
                    {filteredScholarships.length > 0 && (
                        <table>
                            <thead>
                                <tr>
                                    <th>학년도</th>
                                    <th>학기</th>
                                    <th>장학명</th>
                                    <th>장학명(전산)</th>
                                    <th>장학금액</th>
                                    <th>교내외구분</th>
                                    <th>등록일</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredScholarships.map((scholarship, index) => (
                                    <tr key={index}>
                                        <td className="year-cell">{scholarship.year}</td>
                                        <td className="semester-cell">
                                            {formatSemester(scholarship.hakgi)}
                                        </td>
                                        <td className="scholarship-name">
                                            {scholarship.janghak_nm}
                                        </td>
                                        <td className="scholarship-name-jb">
                                            {scholarship.janghak_nm_jb}
                                        </td>
                                        <td className="amount-cell">
                                            {formatAmount(scholarship.jang_amt)}원
                                        </td>
                                        <td className="type-cell">
                                            <span className={`type-badge ${scholarship.gyonaeoe_gb === '교내' ? 'internal' : 'external'}`}>
                                                {scholarship.gyonaeoe_gb}
                                            </span>
                                        </td>
                                        <td className="date-cell">
                                            {scholarship.insert_dt}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}

                    {filteredScholarships.length > 0 && (
                        <div className="summary-box">
                            <div className="summary-item">
                                <span className="summary-label">총 장학금 수혜 건수 :</span>
                                <span className="summary-value">{filteredScholarships.length}건</span>
                            </div>
                            <div className="summary-item">
                                <span className="summary-label">총 장학금액 :</span>
                                <span className="summary-value total-amount">
                                    {formatAmount(
                                        filteredScholarships.reduce((sum, item) => sum + parseInt(item.jang_amt || 0), 0)
                                    )}원
                                </span>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ScholarPage;